export type Source = {
  provider: string;
} & Record<string, unknown>;

export type AddToCartPayload = {
  variant: {
    id: string;
    gtin?: string | null;
    source: Source;
  };
  product: {
    id: string;
    source: Source;
  };
};

const isSource = (source: unknown): source is Source => {
  return (
    typeof source === 'object' &&
    source !== null &&
    'provider' in source &&
    typeof source.provider === 'string'
  );
};

const isProduct = (
  product: unknown
): product is AddToCartPayload['product'] => {
  return (
    typeof product === 'object' &&
    product !== null &&
    'id' in product &&
    typeof product.id === 'string' &&
    'source' in product &&
    typeof product.source === 'object' &&
    product.source !== null &&
    isSource(product.source)
  );
};

const isVariant = (
  variant: unknown
): variant is AddToCartPayload['variant'] => {
  return (
    typeof variant === 'object' &&
    variant !== null &&
    'id' in variant &&
    typeof variant.id === 'string' &&
    'source' in variant &&
    typeof variant.source === 'object' &&
    variant.source !== null &&
    isSource(variant.source)
  );
};

export const isAddToCartPayload = (
  payload: unknown
): payload is AddToCartPayload => {
  return (
    typeof payload === 'object' &&
    payload !== null &&
    'variant' in payload &&
    isVariant(payload.variant) &&
    'product' in payload &&
    isProduct(payload.product)
  );
};
